import { render, staticRenderFns } from "./AddNewButton.vue?vue&type=template&id=5869d9bc&scoped=true"
import script from "./AddNewButton.vue?vue&type=script&lang=js"
export * from "./AddNewButton.vue?vue&type=script&lang=js"
import style0 from "./AddNewButton.vue?vue&type=style&index=0&id=5869d9bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5869d9bc",
  null
  
)

export default component.exports